import { Environment } from './environment.type';

export const environment: Environment = {
  name: 'development',
  production: false,
  adyen: {
    clientKey: 'test_SQ6WSUB5GFGNJFPOFXNNZ4V2E4EAX3PS',
    environment: 'test',
  },
  endpoints: {
    wombat: 'https://links.dev.kody.services',
    payByBank: 'https://paybybank-dev.kody.services',
    brandAssets: 'https://l-dev.kodypay.com/brands',
  },
  coralogix: {
    apiKey: 'cxtp_wqKKEsy4gobFvE5S2ny6IeJFViUne9',
    domain: 'EU2',
  },
  launchDarkly: {
    clientId: '62d80d1a2e3d8411b2d225c9',
  },
  googlePay: {
    countryCode: 'GB',
    environment: 'TEST',
    gatewayMerchantId: 'KodyPay_ECOM_BP',
    merchantId: 'BCR2DN4TU3J65FR4',
  },
};
